import { Component, OnInit,ViewEncapsulation } from '@angular/core';
declare var jQuery: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    (function ($) {
      var $wrapper = $('.main-wrapper');
	var $pageWrapper = $('.page-wrapper');
	var $slimScrolls = $('.slimscroll');
  
      $(document).ready(function(){
        $('body').append('<div class="sidebar-overlay"></div>');
   $(document).on('click', '#mobile_btn', function() {
     $wrapper.toggleClass('slide-nav');
     $('.sidebar-overlay').toggleClass('opened');
     $('html').addClass('menu-opened');
     return false;
   });
   
   // Sidebar overlay
   
   $(".sidebar-overlay").on("click", function () {
     $wrapper.removeClass('slide-nav');
     $(".sidebar-overlay").removeClass("opened");
     $('html').removeClass('menu-opened');
   });
   
   // Page Content Height
   
   if($('.page-wrapper').length > 0 ){
     var height = $(window).height();	
     $(".page-wrapper").css("min-height", height);
   }
   
   // Page Content Height Resize
   
   $(window).resize(function(){
     if($('.page-wrapper').length > 0 ){
       var height = $(window).height();
       $(".page-wrapper").css("min-height", height);
     }
   });
      });
    })(jQuery);
  }

 	// Mobile menu sidebar overlay
 
  

}
